// src/locales/si/brands.js
export const brands = {
  // Page titles and descriptions
  title: "නිෂ්පාදන සන්නාම",
  description: "වඩා හොඳ සංවිධානය සහ පාරිභෝගික හඳුනාගැනීම සඳහා නිෂ්පාදන සන්නාම කළමනාකරණය කරන්න",
  
  // Navigation
  addBrand: "සන්නාමය එක් කරන්න",
  createNewBrand: "නව සන්නාමයක් සාදන්න",
  editBrand: "සන්නාමය සංස්කරණය කරන්න",
  createFirstBrand: "පළමු සන්නාමය සාදන්න",
  
  // Form Fields
  brandName: "සන්නාම නාමය",
  brandNamePlaceholder: "සන්නාම නාමය ඇතුළත් කරන්න (උදා: නයිකි, සැම්සුන්, ඇපල්)",
  brandDescription: "සන්නාම විස්තරය",
  brandDescriptionPlaceholder: "සන්නාමය පිළිබඳ කෙටි විස්තරයක් ඇතුළත් කරන්න",
  brandLogo: "සන්නාම ලාංඡනය",
  uploadLogo: "ලාංඡනය උඩුගත කරන්න",
  chooseLogo: "ලාංඡනය තෝරන්න",
  removeLogo: "ලාංඡනය ඉවත් කරන්න",
  logoHint: "පිළිගත් ආකෘති: JPG, PNG, WEBP. උපරිම ප්‍රමාණය: 2MB",
  
  // Table Headers and Content
  filteredResults: "සන්නාම {{total}} න් {{count}}",
  totalBrands: "සන්නාම {{count}}",
  searchBrands: "නම හෝ විස්තරය මගින් සන්නාම සොයන්න...",
  
  // Selector specific
  selectBrand: "සන්නාමය තෝරන්න",
  searchBrandsPlaceholder: "සන්නාම සොයන්න...",
  noBrandsFound: "ඔබේ සෙවුමට ගැලපෙන සන්නාම හමු නොවීය",
  noBrandsAvailable: "සන්නාම නොමැත",
  createBrand: "සන්නාමය සාදන්න",
  
  // Validation Messages
  nameRequired: "සන්නාම නාමය අවශ්‍යයි",
  nameMinLength: "සන්නාම නාමය අවම වශයෙන් අක්ෂර 2ක් විය යුතුයි",
  nameMaxLength: "සන්නාම නාමය අක්ෂර 100 ඉක්මවිය නොහැක",
  duplicateNameError: "මෙම නමින් සන්නාමයක් දැනටමත් පවතී",
  invalidLogoType: "කරුණාකර වලංගු රූප ගොනුවක් උඩුගත කරන්න (JPG, PNG, WEBP)",
  logoTooLarge: "ලාංඡන ගොනු ප්‍රමාණය 2MB ට අඩු විය යුතුයි",
  
  // Actions
  createBrand: "සන්නාමය සාදන්න",
  updateBrand: "සන්නාමය යාවත්කාලීන කරන්න",
  savingBrand: "සුරකිමින්...",
  
  // Success/Error Messages
  brandCreatedSuccess: "'{{brandName}}' සන්නාමය සාර්ථකව සාදන ලදී!",
  brandUpdatedSuccess: "'{{brandName}}' සන්නාමය සාර්ථකව යාවත්කාලීන කරන ලදී!",
  brandDeletedSuccess: "'{{brandName}}' සන්නාමය සාර්ථකව මකා දමා ඇත.",
  failedToCreate: "සන්නාමය සෑදීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToUpdate: "සන්නාමය යාවත්කාලීන කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToDelete: "සන්නාමය මකා දැමීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  failedToLoadBrand: "සන්නාම විස්තර පූරණය කිරීමට අසමත් විය. කරුණාකර නැවත උත්සාහ කරන්න.",
  
  // Loading states
  loadingBrands: "සන්නාම පූරණය වෙමින්...",
  loadingBrandsDesc: "කරුණාකර අපි ඔබේ නිෂ්පාදන සන්නාම ලබා ගන්නා තෙක් රැඳී සිටින්න.",
  
  // Empty states
  noBrands: "තවම සන්නාම නැත",
  noBrandsDesc: "නිෂ්පාදක හෝ සන්නාම අනුව ඔබේ නිෂ්පාදන සංවිධානය කිරීම ආරම්භ කිරීමට ඔබේ පළමු නිෂ්පාදන සන්නාමය සාදන්න.",
  noSearchResults: "සන්නාම හමු නොවීය",
  noSearchResultsDesc: "ඔබේ සෙවුම් පද සකස් කිරීමට උත්සාහ කරන්න හෝ සියලුම සන්නාම බැලීමට පෙරහන් ඉවත් කරන්න.",
  
  // Confirmation dialogs
  confirmDelete: "ඔබට විශ්වාසද '{{brandName}}' සන්නාමය මකා දැමීමට? මෙම ක්‍රියාව අහෝසි කළ නොහැකි අතර මෙම සන්නාමය භාවිතා කරන නිෂ්පාදන වලට බලපෑ හැකිය."
};